import React from "react";
import "./Datenschutz.css";

export default function Datenschutz() {
  return (
    <main className="ds-page">
      {/* Hero */}
      <section className="ds-hero">
        <div className="ds-hero-inner">
          <span className="ds-badge">EG-BAU</span>
          <h1>Datenschutzerklärung</h1>
          <p className="ds-sub">Informationen gemäß Art. 13 DSGVO</p>
        </div>
      </section>

      {/* Content */}
      <section className="ds-wrap">
        <div className="ds-card">

          <h2>1. Verantwortlicher</h2>
          <p>
            <strong>EG-BAU</strong><br />
            Inhaber: Egzon Gjocaj<br />
            Lister Damm 35<br />
            30163 Hannover<br />
            E-Mail: <a href="mailto:info@gala-egbau.de">info@gala-egbau.de</a><br />
            Telefon: <a href="tel:+4915155629922">+49 151 5562 9922</a>
          </p>

          <h2>2. Allgemeine Hinweise</h2>
          <p>
            Der Schutz Ihrer persönlichen Daten ist uns wichtig. Wir behandeln Ihre Daten
            vertraulich und entsprechend der gesetzlichen Vorschriften sowie dieser
            Datenschutzerklärung.
          </p>

          <h2>3. Erhebung und Speicherung personenbezogener Daten</h2>
          <p><strong>a) Beim Besuch der Website</strong><br />
            Beim Aufrufen unserer Website werden durch unseren Hosting-Provider automatisch
            Server-Logfiles gespeichert (z. B. IP-Adresse, Datum/Uhrzeit, User-Agent,
            angefragte Seite, Referrer). Die Verarbeitung ist technisch erforderlich, um
            die Website bereitzustellen und die Systemsicherheit zu gewährleisten
            (Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO – berechtigtes Interesse).
          </p>
          <p><strong>b) Kontaktformular</strong><br />
            Wenn Sie uns über das Formular kontaktieren, verarbeiten wir die von Ihnen
            eingegebenen Angaben (Name, E-Mail, optional Telefon, Nachricht) zur
            Bearbeitung Ihrer Anfrage (Art. 6 Abs. 1 lit. b DSGVO – vorvertragliche
            Maßnahmen bzw. Art. 6 Abs. 1 lit. f DSGVO – berechtigtes Interesse an
            Kommunikation). Eine Weitergabe an Dritte erfolgt nicht.
          </p>
          <p><strong>c) Hosting / Auftragsverarbeitung</strong><br />
            Unsere Website wird bei <strong>Netlify</strong> betrieben, einem Server-Provider aus den USA. Der Provider verarbeitet die oben
            genannten Daten in unserem Auftrag (Art. 28 DSGVO). Es besteht ein
            Auftragsverarbeitungsvertrag (AVV). Rechtsgrundlage ist Art. 6 Abs. 1 lit. f
            DSGVO (berechtigtes Interesse an einer sicheren und effizienten
            Bereitstellung der Website).
          </p>

          <h2>4. Verwendung von Google Maps</h2>
          <p>
            Zur Darstellung unseres Standorts binden wir Google Maps ein. Beim Aufruf der
            Karten kann Ihre IP-Adresse an Google übertragen werden.
            Anbieter: Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland.
            Datenschutzhinweise: <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">https://policies.google.com/privacy</a>.
            Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (Interesse an ansprechender
            Darstellung/Anfahrt) bzw. – sofern eine Einwilligungslösung (z. B. Cookie-Banner)
            vorgeschaltet ist – Art. 6 Abs. 1 lit. a DSGVO.
          </p>

          <h2>5. Kommunikation über WhatsApp</h2>
          <p>
            Wenn Sie per WhatsApp Kontakt aufnehmen, gelten die Datenschutzbestimmungen von
            WhatsApp. Anbieter: WhatsApp Ireland Limited, 4 Grand Canal Square, Dublin 2,
            Irland. Hinweise:{" "}
            <a href="https://www.whatsapp.com/legal/privacy-policy-eea" target="_blank" rel="noreferrer">
              https://www.whatsapp.com/legal/privacy-policy-eea
            </a>.
            Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Kommunikation) bzw. lit. f DSGVO.
          </p>

          <h2>6. Ihre Rechte</h2>
          <p>
            Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der
            Verarbeitung, Datenübertragbarkeit sowie Widerruf erteilter Einwilligungen.
            Wenden Sie sich dazu an <a href="mailto:info@gala-egbau.de">info@gala-egbau.de</a>.
          </p>

          <h2>7. Beschwerderecht</h2>
          <p>
            Sie können sich bei einer Aufsichtsbehörde beschweren, z. B. bei der
            Landesbeauftragten für den Datenschutz Niedersachsen:
            <a href="https://lfd.niedersachsen.de" target="_blank" rel="noreferrer"> https://lfd.niedersachsen.de</a>.
          </p>

          <h2>8. Sicherheit / SSL- bzw. TLS-Verschlüsselung</h2>
          <p>
            Diese Seite nutzt aus Sicherheitsgründen eine SSL-/TLS-Verschlüsselung. Eine
            verschlüsselte Verbindung erkennen Sie u. a. am „https://“ und am Schloss-Symbol
            in der Adresszeile Ihres Browsers.
          </p>

          <h2>9. Speicherdauer</h2>
          <p>
            Server-Logs werden vom Provider typischerweise für kurze Zeit zur
            Störungsanalyse vorgehalten und anschließend gelöscht oder anonymisiert.
            Kontaktanfragen speichern wir nur so lange, wie es zur Bearbeitung erforderlich
            ist; gesetzliche Aufbewahrungsfristen bleiben unberührt.
          </p>

          <h2>10. Cookies / Tracking</h2>
          <p>
            Wir setzen keinerlei Cookies ein.
          </p>

          <h2>11. Aktualisierung dieser Erklärung</h2>
          <p>
            Wir behalten uns vor, diese Datenschutzerklärung anzupassen, wenn sich
            technische oder rechtliche Anforderungen ändern.
          </p>
        </div>
      </section>
    </main>
  );
}
